import { breakpoints } from '../utils/breakpoints';

const selectors = {
  section: '.js-sticky-section',
};

const handleMobileStickySection = () => {
  if (breakpoints.tablet < window.innerWidth) return;

  const section = document.querySelector(selectors.section);

  if (!section) return;

  section.dataset.scrollOffset = '140%, 100%';
};

export default handleMobileStickySection;
